import React, { FC } from 'react'
import { Table } from '@wmgtech/legato'
import { ColumnsType } from '@wmgtech/legato/build/components/Table'

import { ArtistAvatar } from 'components'
import { FollowButton } from 'modulesCommon/Follow/containers'

import { FollowedProjectsProps } from './FollowedProjects.props'
import { IFollowedProjects } from '../../types'

const FollowedProjects: FC<FollowedProjectsProps> = ({ projects }) => {
  const columns: ColumnsType<IFollowedProjects>[] = [
    {
      dataIndex: 'avatar',
      key: 'avatar',
      title: '',
      sortable: false,
      width: 100,
      render: (value, data) => (
        <ArtistAvatar
          spotifyId={data.spotifyId}
          facebookId={data.facebookId}
          className="notifications__avatar"
          size="xs"
          isImage
        />
      )
    },
    {
      dataIndex: 'artistName',
      key: 'artistName',
      title: 'Artist',
      sortable: false
    },
    {
      dataIndex: 'projectName',
      key: 'projectName',
      title: 'Project',
      sortable: false
    },
    {
      dataIndex: 'count',
      key: 'count',
      title: 'Unread Stories',
      sortable: false,
      render: (value, project) =>
        `${project.storyCount} ${project.storyCount === 1 ? 'Story' : 'Stories'}`
    },
    {
      dataIndex: 'follow',
      key: 'follow',
      title: 'Follow Status',
      sortable: false,
      render: (value, data) => (
        <FollowButton projectId={data.id} userId={data.ownerId} projectName={`${data.artistName}, ${data.projectName}`} />
      )
    }
  ]

  return (
    <div>
      <div className="notifications__header">
        <h2 className="notifications__title">Projects</h2>
        <div>
          Below are the Active Projects in Storybox that you are Following. The most recently active are at the top.
        </div>
      </div>
      <Table
        className="notifications__table"
        rowKey={(record: IFollowedProjects) => record.id}
        columns={columns}
        data={projects}
        pagination={false}
      />
    </div>
  )
}

export default FollowedProjects
